import { WireParty } from 'scenes/common/api/quote/types';
import {
  defaultParty,
  mapPrimaryPolicyHolderCompany,
  mapPrimaryPolicyHolderPerson,
  toAdditionalPolicyHolders,
} from 'scenes/common/api/quote/marshaller/party';

import {
  getBusinessOwnerDateOfBirth,
  getClaimsMade,
  getPolicyHolderDateOfBirth,
  getYearsInsured,
  isPolicyIssuedToPerson,
  getContactEmailAddress,
  getContactPhoneNumber,
  getPersonalContactFirstName,
  getPersonalContactLastName,
  getBusinessContactFirstName,
  getBusinessContactLastName,
  getBusinessAbn,
  getAdditionalPolicyHolders,
  getBusinessName,
  isPropertyUsedForBusiness,
  isBusinessRegisteredForGst,
  getBusinessRegisteredForGst,
} from 'scenes/home/selectors';
import { HomeFunnelState } from 'scenes/home/types';

const toPrimaryPolicyHolder = (state: HomeFunnelState): WireParty => ({
  ...defaultParty,
  ...(isPolicyIssuedToPerson(state)
    ? mapPrimaryPolicyHolderPerson(
        getPersonalContactFirstName(state),
        getPersonalContactLastName(state),
        getPolicyHolderDateOfBirth(state)
      )
    : mapPrimaryPolicyHolderCompany(
        getBusinessContactFirstName(state),
        getBusinessContactLastName(state),
        getBusinessOwnerDateOfBirth(state),
        getBusinessAbn(state),
        getBusinessName(state)
      )),
  email: getContactEmailAddress(state).trim(),
  mobile: getContactPhoneNumber(state),
  claims: { last3Years: getClaimsMade(state).toString() },
  numberOfYearsInsured: getYearsInsured(state).toString(),
  isTaxExempted:
    isPropertyUsedForBusiness(state) && getBusinessRegisteredForGst(state)
      ? !isBusinessRegisteredForGst(state)
      : undefined,
});

export const toWireHomeParties = (state: HomeFunnelState): WireParty[] => [
  toPrimaryPolicyHolder(state),
  ...toAdditionalPolicyHolders(getAdditionalPolicyHolders(state)),
];

export const partyRefIds = (state: HomeFunnelState): string[] => [
  ...toWireHomeParties(state).map((party) => party.id),
];
